import { Component } from '@angular/core';

/** aggressively render only navtabs version */
@Component({
  selector: 'app-feature-flag-tabs',
  templateUrl: './feature-flag-tabs.component.html',
})
export class FeatureFlagTabsComponent {
}
